import type { QueryOptionsOverride } from '../queryOptions.helpers';
import type { PaginationType } from '../types/Pagination.types';
import z from 'zod';
import { createUpdateZodSchema } from '../types/DateUtils.types';
import { PaginationParamsSchema } from '../types/Pagination.types';

/** Create Game Review DTO */
export const CreateGameReviewDtoSchema = z.object({
  rating: z.number().min(1, 'Rating must be at least 1').max(5, 'Rating must be at most 5'),
  comment: z.string().max(1000),
  username: z.string().optional(),
});

export type CreateGameReviewDto = z.infer<typeof CreateGameReviewDtoSchema>;

/** Game Review DTO */
export const GameReviewDtoSchema = z.object({
  id: z.string().uuid(),
  gameId: z.string().uuid(),
  rating: z.number(),
  comment: z.string(),
  // use string it's doesn't matter here
  status: z.string(),

  adminId: z.string().uuid().nullable(),
  // TODO: update to UserSnapshot type
  user: z.any().nullable(),
  userId: z.string().uuid().nullable(),
  username: z.string().nullable(),
}).merge(createUpdateZodSchema);

export type GameReviewDto = z.infer<typeof GameReviewDtoSchema>;
export type GameReviewListDto = PaginationType<GameReviewDto>;

export type GameReviewsUseQueryParams = {
  gameId: string;
  params?: GameReviewParams;
  options?: QueryOptionsOverride<GameReviewListDto>;
};
/** Game Review Parameters */
export const GameReviewParamsSchema = PaginationParamsSchema();
export type GameReviewParams = z.infer<typeof GameReviewParamsSchema>;
